import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard/Dashboard.js";
import Login from "./components/Login/Login.js";
import Preferences from "./components/Preferences/Preferences.js";
import useToken from "./components/App/useToken.js";
import Navbar from "./components/NavBar/Navbar.js";
import ProductGroups from "./components/ProdGroups/ProdGroups.js";
import ProductCategory from "./components/Category/CategoryList.js";
import ProductList from "./components/Product/ProductList.js";
import ProductDetail from "./components/Product/ProductDetail.js";
import NotFound404 from "./components/Common/NotFound404.js";
import CallBackPage from "./components/Common/CallBackPage.js";
import AboutUs from "./components/Common/AboutUs.js";
import ContactUs from "./components/Common/ContactUs.js";
import UserDetailView from "./components/User/UserDetailView.js";
import axios from "axios";
import ReactGA from "react-ga4";
import Home from "./components/Home/Home.js";
import CategoryListforAdmin from "./components/Admin/CategoryAdmin/CategoryListforAdmin.js";
import ProductAdminList from "./components/Admin/ProductAdmin/ProductAdminList.js";
import ProductAdminListforDisplayImg from "./components/Admin/ProductAdmin/ProductAdminListforDisplayImg.js";
import LastChanceDeals from "./components/LastChanceDeals/LastChanceDeals.js";
import Cart from "./components/Cart/Cart.js";
import CartOverView from "./components/Cart/CartOverView.js";
import MyOrders from "./components/User/MyOrders.js";
import OrderDetail from "./components/User/OrderDetail.js";
import NewArrival from "./components/NewArrival/NewArrival.js";
import ManageNewArrival from "./components/Admin/NewArrival/ManageNewArrival.js";
import AdminNavbar from "./components/Admin/AdminNavBar/AdminNavbar";
import ManageLastChanceDeals from "./components/Admin/ManageLastChanceDeal/ManageLastChanceDeal.js";
import ManageProductTags from "./components/Admin/ProductAdmin/ProductTags/ManageProductTags.js";
import UserList from "./components/Admin/ManageUser/UserList.js";
import ManageTrendingItems from "./components/Admin/TrendingItems/ManageTrendingItems.js";
import TrendingItemsList from "./components/TrendingItems/TrendingItemsList.js";
import UserActivitySummary from "./components/Admin/UserActivityMonitor/UserActivitySummary.js";
import UserActivityOverView from "./components/Admin/UserActivityMonitor/UserActivityOverView.js";
import ArrangeCategorySequence from "./components/Admin/CategoryAdmin/ArrangeCategorySequence.js";
import InstaPostSchedule from "./components/Admin/InstaPost/InstaPostSchedule.js";
import UserDetails from "./components/Admin/ManageUser/UserDetails.js";
import AdminDashBoard from "./components/Admin/DashBoard/AdminDashBoard.js";
// Add the campaign page import
import AdDiamondPendantCMP from "./components/campaignPages/AdDiamondPendantCMP.js";
import LeadsToApprove from "./components/Admin/CRM/LeadsToApprove.js";
import MyDownloads from "./components/MyDownloads/MyDownloads.js";
import ProductUpdates from "./components/Productupdates/ProductUpdates.js";
import NewLaunch from "./components/Admin/NewLaunch/NewLaunch.js";
import BookProduct from "./components/BookProduct/BookProduct.js";
import SupplierOrders from "./components/Admin/Supplier/SupplierOrders.js";

ReactGA.initialize("G-4FW71Y2EX2");

// Update the extractUrlParameters function to handle malformed URLs
const extractUrlParameters = () => {
  const params = new URLSearchParams(window.location.search);
  let pathSegments = window.location.pathname.split("/").filter(Boolean);

  let mob = params.get("mob");
  let category = null;

  // Handle malformed URL where & is used instead of ?
  if (pathSegments.length > 1) {
    let categorySegment = decodeURIComponent(pathSegments[1]);

    // Check if category segment contains mob parameter (malformed URL)
    if (categorySegment.includes("&mob=")) {
      const parts = categorySegment.split("&mob=");
      category = parts[0]; // The actual category
      mob = mob || parts[1]; // Extract mob from path if not in query
    } else {
      category = categorySegment;
    }
  }

  return {
    mob: mob,
    category: category,
    fullPath: window.location.pathname,
    searchParams: window.location.search,
  };
};

// Add this helper function to clean mobile number
const cleanMobileNumber = (mobileNo) => {
  if (!mobileNo) return null;

  // Remove all non-digit characters
  let cleaned = mobileNo.replace(/\D/g, "");

  // Remove leading +91 or 91
  if (cleaned.startsWith("91") && cleaned.length > 10) {
    cleaned = cleaned.substring(2);
  }

  // Check if it's exactly 10 digits
  if (cleaned.length === 10) {
    return cleaned;
  }

  return null; // Invalid mobile number
};

// Add this function to log mobile activity
const logMobileActivity = async (mobileNo) => {
  try {
    const cleanedMobile = cleanMobileNumber(mobileNo);

    if (!cleanedMobile) {
      console.error("Invalid mobile number format:", mobileNo);
      return;
    }

    const config = {
      method: "post",
      url: `${global.config.APIURL.BaseURL}api/PublicData/LogURL?MobileNo=${cleanedMobile}&ScreenID=1004`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    await axios.request(config);
    console.log("Mobile activity logged successfully for:", cleanedMobile);
  } catch (error) {
    console.error("Error logging mobile activity:", error);
  }
};

function App() {
  const { token, setToken } = useToken();
  const [userName, setUserName] = useState("");
  const [cartCount, setCartCount] = useState(0);
  const [allowToOrder, setAllowToOrder] = useState(false);

  // Add domain detection
  const currentDomain = window.location.hostname;
  const isLocalhost =
    currentDomain === "localhost" || currentDomain === "127.0.0.1";
  const isAdminDomain = currentDomain === "admin.thejoj.com";
  const canAccessAdminRoutes = isLocalhost || isAdminDomain;

  // Fetch cart overview when user is logged in
  useEffect(() => {
    if (token) {
      fetchCartOverview();
    }
  }, [token]);

  const fetchCartOverview = async () => {
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.get(
        global.config.APIURL.BaseURL + "api/UserCart/GetCartOverView",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      if (response.status === 200 && response.data) {
        setCartCount(response.data.NoOfItem || 0);
      }
    } catch (error) {
      setCartCount(0);
    }
  };

  useEffect(() => {
    const IsEmployee = localStorage.getItem("IsEmployee");

    if (IsEmployee === "false") {
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }
    // Only call checkUserActiveStatus if token is available
    if (token) {
      checkUserActiveStatus();
    }
    // Set userName from localStorage if not already set
    if (!userName) {
      setUserName(localStorage.getItem("userName") || "");
    }
    // define a custom handler function
    // for the contextmenu event
    const handleContextMenu = (e) => {
      // prevent the right-click menu from appearing
      e.preventDefault();
    };

    // attach the event listener to
    // the document object
    document.addEventListener("contextmenu", handleContextMenu);

    // clean up the event listener when
    // the component unmounts
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [token, userName]);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          setAllowToOrder(response.data.AllowtoOrder === true);
          // Set userName from API if not already set
          if (!userName && response.data.OwnerName) {
            setUserName(response.data.OwnerName);
            localStorage.setItem("userName", response.data.OwnerName);
          }
          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === false
          ) {
            alert("Your session has expired. Please log in again.");
            setToken(null);
            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.reload();
          }
        })
        .catch((error) => { });
    } catch (error) { }
  };

  // List of admin routes
  const adminRoutes = [
    "/AdminDashBoard",
    "/AdminProductChangeImg",
    "/ManageNewArrival",
    "/AdminProduct",
    "/AdminCategory",
    "/ManageLastChanceDeals",
    "/ManageProductTags",
    "/UserList",
    "/ManageTrendingItems",
    "/UserActivitySummary",
    "/ArrangeCategorySequence",
    "/InstaPostSchedule",
    "/UserDetails",
    "/LeadsToApprove",
    "/UserActivityOverView",
    "/NewLaunch", // <-- Added
    "/SupplierOrders",
  ];

  // Add standalone routes that don't need navbar
  const standaloneRoutes = ["/diamond-pendant-offer", "/campaign", "/book-product"];

  // Add login route as a constant
  const loginRoute = "/login";

  // Get current path
  const currentPath = window.location.pathname;

  // Helper: case-insensitive admin route check
  const isAdminRoute = adminRoutes.some(
    (route) => route.toLowerCase() === currentPath.toLowerCase()
  );

  // Check if current path is login route
  const isLoginRoute = currentPath.toLowerCase() === loginRoute;

  // Check if current path is a standalone route (no navbar needed)
  const isStandaloneRoute = standaloneRoutes.some(
    (route) => currentPath.toLowerCase().startsWith(route.toLowerCase())
  );

  // List of routes that require login (user-only pages)
  const userProtectedRoutes = [
    "/userdetailview",
    "/cartoverview",
    "/cart",
    "/myorders",
    "/orderdetail",
    "/newarrival",
    "/lastchancedeals",
    "/trendingitems",
    "/mydownloads", // <-- Added
  ];

  // Check if current path matches any user protected route (including dynamic params)
  const isUserProtectedRoute = userProtectedRoutes.some((route) =>
    currentPath.toLowerCase().startsWith(route)
  );

  // Remove username if token is not set
  if (!token) {
    localStorage.removeItem("userName");
    if (userName) setUserName("");
  }

  // DOMAIN-BASED ROUTING LOGIC
  // If trying to access admin route without permission, show 404
  if (isAdminRoute && !canAccessAdminRoutes) {
    return <NotFound404 />;
  }

  // If admin domain accessing root path, redirect to AdminDashBoard instead of AdminCategory
  if (isAdminDomain && currentPath === "/" && token) {
    window.location.href = "/AdminDashBoard";
    return null;
  }

  // If admin domain accessing root path without token, show login
  if (isAdminDomain && currentPath === "/" && !token) {
    return <Login setToken={setToken} />;
  }

  // Handle standalone routes (no navbar, no authentication required)
  if (isStandaloneRoute) {
    return (
      <div
        style={{
          background: "#f5f5f5",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <Router>
          <Routes>
            <Route path="/campaign" element={<AdDiamondPendantCMP />} />
            <Route path="/book-product/:dataString" element={<BookProduct />} />
          </Routes>
        </Router>
      </div>
    );
  }

  // Redirect to login if trying to access admin or user-protected route without token
  if (
    (isAdminRoute && !token) ||
    isLoginRoute ||
    (isUserProtectedRoute && !token)
  ) {
    // Extract parameters from current URL
    const urlParams = extractUrlParameters();

    // Log mobile activity if it's newarrival page with mob and category
    if (
      urlParams.fullPath.includes("newarrival") &&
      urlParams.mob &&
      urlParams.category
    ) {
      // Call the mobile logging API before redirecting to login
      logMobileActivity(urlParams.mob);
      console.log("Logging mobile activity for newarrival:", {
        mobile: urlParams.mob,
        category: urlParams.category,
        path: urlParams.fullPath,
      });
    }

    // Pass the extracted parameters to Login component
    return <Login setToken={setToken} urlParams={urlParams} />;
  }

  return (
    <div
      style={{
        background: "#f5f5f5",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div
        className="wrapper"
        style={{
          maxWidth: isAdminRoute ? "100%" : 1200,
          margin: "auto",
        }}
      >
        <title>Jewels Of Joy</title>
        <Router>
          {/* Show AdminNavbar for admin pages, Navbar for customer pages */}
          {isAdminRoute ? (
            <AdminNavbar userName={userName} />
          ) : (
            <Navbar
              userName={userName}
              cartCount={cartCount}
              allowToOrder={allowToOrder}
            />
          )}
          <Routes>
            {/* CAMPAIGN ROUTES - Standalone pages without navbar */}
            <Route
              path="/diamond-pendant-offer"
              element={<AdDiamondPendantCMP />}
            />
            <Route path="/campaign" element={<AdDiamondPendantCMP />} />
            {/* USER ROUTES - Available to all domains */}
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<ProductCategory />} />
            <Route path="/productgroups" element={<ProductGroups />} />
            <Route path="/productcategories" element={<ProductCategory />} />
            <Route
              path="/shop/:categoryName/:categoryIDQuery"
              element={<ProductList refreshCartCount={fetchCartOverview} />}
            />
            <Route
              path="/shop/:category/:product/:productIdQuery"
              element={<ProductDetail refreshCartCount={fetchCartOverview} />}
            />
            <Route path="/callbackpage" element={<CallBackPage />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/userdetailview" element={<UserDetailView />} />
            <Route
              path="/cartoverview"
              element={<CartOverView refreshCartCount={fetchCartOverview} />}
            />
            <Route
              path="/cart"
              element={<Cart refreshCartCount={fetchCartOverview} />}
            />
            <Route path="/myorders" element={<MyOrders />} />
            <Route path="/orderdetail/:OrderID" element={<OrderDetail />} />
            <Route
              path="/newarrival"
              element={<NewArrival refreshCartCount={fetchCartOverview} />}
            />
            <Route
              path="/newarrival/:categoryName"
              element={<NewArrival refreshCartCount={fetchCartOverview} />}
            />
            <Route
              path="/trendingitems"
              element={
                <TrendingItemsList refreshCartCount={fetchCartOverview} />
              }
            />
            <Route
              path="/trendingitems/:categoryName"
              element={
                <TrendingItemsList refreshCartCount={fetchCartOverview} />
              }
            />
            <Route
              path="/lastchancedeals"
              element={<LastChanceDeals refreshCartCount={fetchCartOverview} />}
            />
            <Route path="/mydownloads" element={<MyDownloads />} />{" "}
            <Route path="/new-launches" element={<ProductUpdates />} />
            <Route path="/book-product/:dataString" element={<BookProduct />} />
            {/* <-- Added */}
            {/* ADMIN ROUTES - Only available to localhost or admin.thejoj.com */}
            {canAccessAdminRoutes && (
              <>
                <Route
                  path="/AdminCategory"
                  element={<CategoryListforAdmin />}
                />
                <Route path="/AdminProduct" element={<ProductAdminList />} />
                <Route
                  path="/AdminProductChangeImg"
                  element={<ProductAdminListforDisplayImg />}
                />
                <Route
                  path="/ManageNewArrival"
                  element={<ManageNewArrival />}
                />
                <Route
                  path="/ManageLastChanceDeals"
                  element={<ManageLastChanceDeals />}
                />
                <Route
                  path="/ManageProductTags"
                  element={<ManageProductTags />}
                />
                <Route path="/UserList" element={<UserList />} />
                <Route
                  path="/ManageTrendingItems"
                  element={<ManageTrendingItems />}
                />
                <Route
                  path="/UserActivitySummary"
                  element={<UserActivitySummary />}
                />
                <Route
                  path="/ArrangeCategorySequence"
                  element={<ArrangeCategorySequence />}
                />
                <Route
                  path="/InstaPostSchedule"
                  element={<InstaPostSchedule />}
                />
                <Route path="/UserDetails/:userId" element={<UserDetails />} />
                <Route path="/AdminDashBoard" element={<AdminDashBoard />} />
                <Route path="/LeadsToApprove" element={<LeadsToApprove />} />
                <Route
                  path="/UserActivityOverView"
                  element={<UserActivityOverView />}
                />{" "}
                <Route path="/NewLaunch" element={<NewLaunch />} />
                {/* <-- Added */}
                <Route path="/SupplierOrders" element={<SupplierOrders />} />
              </>
            )}
            {/* Catch all route */}
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;
